import { Box, FormControlLabel, Grid, Switch, Typography } from "@mui/material";
import { IScoreVeles, ScoreVelesKeys } from "../../../../../../../application/models";
import { HeaderFiltro } from "../header-filtro";
import { useAppSelector } from "../../../../../../hooks/store-hooks";
import { useProjetosService } from "../../../../../../../use-cases/geo-veles";

export const scoreDescriptionToLabel = (scoreDescriptionKey: IScoreVeles) => {
    switch (scoreDescriptionKey) {
        case 'ALTISSIMO RISCO':
            return 'ALTÍSSIMO RISCO';
        case 'ALTO RISCO':
            return 'ALTO RISCO';
        case 'MEDIO RISCO':
            return 'MÉDIO RISCO';
        case 'BAIXISSIMO RISCO':
            return 'BAIXÍSSIMO RISCO';
        case 'BAIXO RISCO':
            return 'BAIXO RISCO';
        default:
            return 'Não definido';
    }
};

export const FiltroScore = () => {
    // State
    const { filtrosSelecionados } = useAppSelector((state) => state.projetos);
    // Hook
    const { addScoreVelesFilter, removeScoreVelesFilter } = useProjetosService();

    return (
        <>
            <HeaderFiltro
                titulo="Saúde Financeira"
                descricao={
                    <>
                        <Typography>
                            A opção abaixo possui o intuito de filtrar pessoas a partir do risco de inadimplência.
                        </Typography>
                        <Typography>
                            A <strong>saúde financeira</strong> é resultado de um algoritmo criado pela <strong>Veles</strong>, partindo de diversos dados para que, à partir de uma pontuação, seja possível mensurar o risco de inadimplência de cada pessoa.
                        </Typography>
                        <Typography style={{ marginBottom: '10px' }}>
                            Você pode selecionar mais de um nível de risco diferente.
                        </Typography>
                        <Typography>
                            Caso nenhuma opção seja selecionada, todos os níveis de saúde financeira serão levados em consideração.
                        </Typography>
                    </>
                }
            />

            <Box p={3} style={{ marginTop: '10px' }}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant="h6" color="primary" fontWeight="bold" textTransform={"uppercase"}>
                            Saúde financeira:
                        </Typography>
                    </Grid>
                    {ScoreVelesKeys.map((score) => (
                        <Grid item xs={4} key={score}> {/* key agora corretamente atribuída */}
                            <FormControlLabel
                                label={scoreDescriptionToLabel(score).toUpperCase()}
                                control={
                                    <Switch
                                        checked={filtrosSelecionados?.scoreVeles?.length === 0 ? false : filtrosSelecionados?.scoreVeles?.includes(score) ?? false}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                addScoreVelesFilter(score);
                                            } else {
                                                removeScoreVelesFilter(score);
                                            }
                                        }}
                                    />
                                }
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </>
    );
};
